import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiQueryInput } from '../_models/api-query-input';
import { StateService } from '../_services/state.service';

@Injectable({
  providedIn: 'root',
})
export class BaseApiService implements OnDestroy {
  private _baseApiUrl = environment.apiUrl;
  private _httpOptions = {};
  private _currentLanguage = 'vi';

  constructor(
    protected http: HttpClient,
    protected stateService: StateService,
  ) {
    this.stateService.currentLanguage$.subscribe({
      next: (value: string) => {
        this._currentLanguage = value;
      },
    });
  }

  ngOnDestroy() {
    this.stateService.currentLanguage$.unsubscribe();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set httpOptions(type: any) {
    this._httpOptions = {
      headers: new HttpHeaders({}),
    };
    // 'Content-Type': 'multipart/form-data; boundary=`wL36Yn8afVp8Ag7AmP8qZ0SA4n1v9T`'
    // { 'Content-Type': 'application/json' }
    if (!type) return;
    // this._httpOptions.headers.set(type.key, type.value);
  }

  get httpOptions() {
    return this._httpOptions;
  }

  get baseApiUrl() {
    return this._baseApiUrl;
  }

  protected applyQuery(query?: ApiQueryInput, addLanguage = true): HttpParams {
    let params = new HttpParams();
    if (this._currentLanguage && addLanguage) params = params.set('language', this._currentLanguage);
    for (const key in query) {
      // eslint-disable-next-line no-prototype-builtins
      if (query.hasOwnProperty(key) && query[key] !== undefined) {
        params = params.set(key, query[key] as string);
      }
    }
    return params;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected post<T>(url: string, body: any) {
    return this.http.post<T>(this.baseApiUrl + url, body, this.httpOptions);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected get<T>(url: string, params: any) {
    return this.http.get<T>(this.baseApiUrl + url, { params });
  }
}
